<template>
  <div class="container">
    <div class="top-box">
      <div class="flexrbc">
        <div class="flexr0c">
          <div class="title-label"></div>
          <div class="title">过站信息查询</div>
        </div>
        <div class="addOrg flexrcc" @click="exportTable">
          <div class="btn">导出</div>
        </div>
      </div>
    </div>
    <div class="search-box flexr0c">
      <div class="flexr0c dispatch-time">
        <div class="label">时间范围</div>
        <Row>
          <Col span="12">
            <DatePicker format="yyyy/MM/dd HH:mm:ss" :editable="false" :value="dateRange" type="datetimerange" placement="bottom-end" placeholder="选择日期" style="width: 360px" @on-change="handleChange" @on-ok="handleConfirm" :clearable="false"></DatePicker>
          </Col>
        </Row>
      </div>
      <div class="flexr0c select-box">
        <div class="label">交易矿种</div>
        <Select v-model="select1" style="width: 120px" @on-change="changeStatus">
          <Option v-for="item in oreList" :value="item.value" :key="item.index">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="flexr0c search-item">
        <div class="label">需方企业</div>
        <Input v-model="needCom" placeholder="" style="width: 180px" @on-blur="getPage(1)" @on-enter="getPage(1)">
          <Icon type="ios-search" slot="suffix" />
        </Input>
      </div>
    </div>
    <div class="content-box">
      <div class="content">
        <div class="title-box flexr0c">
          <div class="title">过站/调运车次</div>
          <div class="title">累计重量(吨)</div>
          <!--<div class="title">交易金额(吨)</div>-->
          <div class="title">累计税费(元)</div>
        </div>
        <div class="item-box flexr0c">
          <div class="num num1">{{ moneyObj.totalCount }}</div>
          <div class="num num2">{{ moneyObj.netWeight }}</div>
          <!-- <div class="num num3">{{moneyObj.JY_MONEY}}</div>-->
          <div class="num num4">{{ moneyObj.payMoney }}</div>
        </div>
        <Table max-height="" :loading="loading" border stripe :columns="tableHead" :data="tableData"> </Table>
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page :total="total" :page-size="pageSize" :current="1" @on-change="changePage" show-elevator show-total></Page>
          </div>
        </div>
      </div>
    </div>
    <!-- 电子票 -->
    <Modal v-model="printModal" title="电子票" width="900px"> 
      <div class="table-box" id="printBox">
        <div class="title-box">
          <span class="title">河南省矿产品交收单</span>
        </div>
        <div class="chapter-box">
          <img src="../../assets/imgs/bill/chapter.png"></img>
        </div>
        <div class="subtitle">
          <div class="flex">
            <div class="code-box">
              <div class="code">
                <canvas ref="qrCanvas"></canvas>
              </div>
            </div>
            <div class="area">{{clickInfo.orgName}}</div>
          </div>
          <div class="right">
            <div class="bill">
              <span class="right-msg">No.</span>
              <span>{{ nowYear }}{{ clickInfo.billNo }}{{ clickInfo.oreTypeCode }}</span>
            </div>
            <div>
              <span class="right-msg">日期:</span>
              <span>{{clickInfo.passTime}}</span>
            </div>
          </div>
        </div>
        <div class="table">
          <div class="row">
            <div class="middle-box">
              <div class="label-box">
                <i>供</i>
                <i>方</i>
                <i>会</i>
                <i>员</i>
              </div>
              <div class="fill fill-box">
                <div class="label">名称：</div>
                <div>{{ clickInfo.enterpriseName }}</div>
              </div>
            </div>
            <div class="middle-box">
              <div class="label-box">
                <i>需</i>
                <i>方</i>
                <i>会</i>
                <i>员</i>
              </div>
              <div class="fill fill-box fill-box2">
                <div class="label">名称：</div>
                <div>{{ clickInfo.buyerName }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="row-title">
              <div class="table-title label">合同编号</div>
              <div class="fill">{{clickInfo.billNo}}</div>
            </div>
            <div class="row-title">
              <div class="table-title label">品种名称</div>
              <div class="fill">{{clickInfo.oreName}}</div>
            </div>
            <div class="row-title">
              <div class="table-title label">销售价格(元)</div>
              <div class="fill">{{clickInfo.allPrice}}</div>
            </div>
            <div class="row-title">
              <div class="table-title label">运输车号</div>
              <div class="fill">{{clickInfo.plateNum}}</div>
            </div>
            <div class="row-title">
              <div class="table-title label">核运量(吨)</div>
              <div class="fill">{{clickInfo.allWeight}}</div>
            </div>
            <div class="row-title">
              <div class="table-title label">实运量(吨)</div>
              <div class="fill">{{clickInfo.netWeight}}</div>
            </div>
          </div>
          <div class="row">
            <div class="row-title2">
              <div class="table-title label">装运地点</div>
              <div class="fill">{{clickInfo.sourceArea}}</div>
            </div>
            <div class="row-title2">
              <div class="table-title label">交货地点</div>
              <div class="fill">{{clickInfo.destArea}}</div>
            </div>
          </div>
          <div class="row">
            <div class="middle-box">
              <div class="label-box">
                <i>备</i>
                <i>注</i>
              </div>
              <div class="fill fill-box"></div>
            </div>
            <div class="middle-box">
              <div class="label-box">
                <i>查</i>
                <i>验</i>
                <i>核</i>
                <i>验</i>
              </div>
              <div class="fill fill-box fill-box2">
                <canvas ref="stampCanvas" width="150" height="150" v-show="false"></canvas>
                <img :src="stampImage" alt="Stamp Image" class="chapter" v-show="stampImage">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div style="display: flex;justify-content: center;">
          <Button type="success" style="width: 138px;" v-print='printObj'>打印</Button>
          <Button type="warning" style="width: 138px;" @click="convertToPDF()">下载</Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import html2PDF from 'html2pdf.js';

export default {
  name: 'stationInfo',
  data() {
    return {
      nowYear: '',
      clickInfo: {},
      printObj:{
	      id:'printBox', // 必要，打元素的id
	      popTitle: '打印', // 打印配置页上方标题
	      extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
	      preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
	      previewTitle: '', // 打印预览的标题（开启预览模式后出现）,
	      previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
	      zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）   
	      previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
	      previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
	      beforeOpenCallback() {}, // 开启打印前的回调事件
	      openCallback() {}, // 调用打印之后的回调事件
	      closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
	      url: '',
	      standard: '',
	      extraCss: '',
      },
      printModal: false,
      stampImage: '',
      msg: '',
      dateRange: [],
      carId: '',
      userName: '',
      select1: '',
      select3: '',
      needCom: '',
      oreList: [
        {
          value: '全部',
          label: '全部'
        }
      ],
      moneyObj: {},
      total: 0,
      pageSize: 12,
      loading: true,
      tableHead: [
        {
          title: '矿种',
          key: 'oreName',
          width: 100,
          resizable: true
        },
        {
          title: '入场时间',
          key: 'entryTime',
          width: 190,
          resizable: true
        },
        {
          title: '过站时间',
          key: 'passTime',
          width: 190,
          resizable: true
        },
        {
          title: '过站码',
          key: 'checkCode',
          width: 100,
          resizable: true
        },
        {
          title: '交收单号',
          key: 'billNo',
          width: 130,
          resizable: true
        },
        {
          title: '车牌号码',
          key: 'plateNum',
          width: 110,
          resizable: true
        },
        {
          title: '矿种单价(元)',
          key: 'orePrice',
          width: 130,
          resizable: true
        },
        {
          title: '过站重量(吨)',
          key: 'netWeight',
          width: 130,
          resizable: true
        },
        {
          title: '过站税费(元)',
          key: 'payMoney',
          width: 130,
          align: 'left',
          resizable: true
        },
        {
          title: '交易金额(元)',
          key: 'allPrice',
          width: 130,
          align: 'left',
          resizable: true
        },
        {
          title: '计量站',
          key: 'stationName',
          width: 240,
          align: 'left',
          resizable: true
        },
        {
          title: '调运企业',
          key: 'enterpriseName',
          width: 320,
          align: 'left',
          resizable: true
        },
        {
          title: '需方企业',
          key: 'buyerName',
          width: 240,
          align: 'left',
          resizable: true
        },
        {
          title: '起运地',
          key: 'sourceArea',
          width: 300,
          align: 'left',
          resizable: true
        },
        {
          title: '目的地',
          key: 'destArea',
          width: 120,
          align: 'left',
          resizable: true
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.getPrintInfo(params.row.id);
                    }
                  }
                },
                '电子票'
              )
            ]);
          }
        }
      ],
      tableData: [],
      companyList: []
    };
  },
  created() {
    let date2 = this.dateFormat('YYYY-mm-dd', new Date());
    this.dateRange.push(date2 + ' 00:00:00');
    this.dateRange.push(date2 + ' 23:59:59');
    this.inquireEnterprise();
    this.getSelect();
    this.getYear();
  },
  methods: {
    convertToPDF() {
      const content = document.getElementById('printBox');
      const opt = {
        margin: 1, // 设置边距（以毫米为单位）
        filename: '电子票.pdf', // 设置生成的PDF文件名
        image: { type: 'webp', quality: 1 }, // 设置图片质量
        html2canvas: { dpi: 192, letterRendering: true }, // 设置canvas渲染选项
        jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }, // 设置生成的PDF的单位、格式和方向
      }
      html2PDF().set(opt).from(content).save();
    },
    getPrintInfo(id) {
      const session = JSON.parse(localStorage['session']);
      let data = {
        modeCode: 'AurfrdfQdN5jWoFpt9sYugUgr4cZTsC3',
        sessionId: session.sessionId,
        enterpriseId: session.enterpriseId,
        id,
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.clickInfo = res.data;
          this.createQRCode();
          if(this.clickInfo.ext1) this.drawStamp();
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getYear() {
      const currentYear = new Date().getUTCFullYear();
      this.nowYear = String(currentYear).slice(-2);
    },
    createQRCode() {
      this.printModal = true;
      const canvas = this.$refs.qrCanvas;
      QRCode.toCanvas(canvas, this.clickInfo.id, {
        width: 80,
        height: 80
      }, error => {
        if (error) console.error(error)
      });
    },
    drawStamp() {
      this.stampImage = '';
      const opts = {
        company: this.clickInfo.ext1, // 机构名称
        companyTight: true, // 公司名称是否紧凑(//false 散开型   true紧凑)
      };
      const canvas = this.$refs.stampCanvas;
      const context = canvas.getContext("2d");
      context.restore();
      const width = 70;
      const height = 70;
      context.clearRect(0, 0, canvas.width, canvas.height);
      // 绘制印章边框
      context.lineWidth = 3;
      context.strokeStyle = "#f00";
      context.beginPath();
      context.arc(width, height, 60, 0, Math.PI * 2);
      context.stroke();
      context.save();
      // 画五角星
      context.save();
      context.fillStyle = "#f00";
      context.translate(width, height); // 移动坐标原点
      context.rotate(Math.PI + 0); // 旋转
      context.beginPath(); // 创建路径
      let x = Math.sin(0);
      let y = Math.cos(0);
      let dig = (Math.PI / 5) * 4;
      for (let i = 0; i < 5; i++) {
        // 画五角星的五条边
        let x = Math.sin(i * dig);
        let y = Math.cos(i * dig);
        context.lineTo(x * 22, y * 22);
      }
      context.closePath();
      context.stroke();
      context.fill();
      context.restore();
      // 绘制印章名称
      context.font = "14px Helvetica";
      context.textBaseline = "middle"; // 设置文本的垂直对齐方式
      context.textAlign = "center"; // 设置文本的水平对对齐方式
      context.lineWidth = 1;
      context.fillStyle = "#f00";
      // 绘制印章单位
      context.translate(width, height); // 平移到此位置,
        let count = opts.company.length; // 字数
        if (count > 14) {
          var maxCount = 18;
          context.font = "16px Helvetica";
          if (opts.companyTight) {
            var angle = (4 * Math.PI) / 51; // 字间角度
          } else {
            var angle = (4 * Math.PI) / (3 * (count - 1)); // 字间角度
          }
        } else {
          var maxCount = 14;
          context.font = "16px Helvetica";
          if (opts.companyTight) {
            var angle = (4 * Math.PI) / 39; // 字间角度
          } else {
            var angle = (4 * Math.PI) / (3 * (count - 1)); // 字间角度
          }
        }
        let chars = opts.company.split("");
        let c;
        for (let i = 0; i < count; i++) {
          c = chars[i]; // 需要绘制的字符
          if (i == 0) {
            if (opts.companyTight) {
              context.rotate((5 * Math.PI) / 6 + angle * ((maxCount - count) / 2));
            } else {
              context.rotate((5 * Math.PI) / 6);
            }
          } else {
            context.rotate(angle);
          }
          context.save();
          context.translate(52, 0); // 平移到此位置,此时字和x轴垂直
          context.rotate(Math.PI / 2); // 旋转90度,让字平行于x轴
          context.fillText(c, 0, 5); // 此点为字的中心点
          context.restore();
        }
      // 将canvas转换为图片源
      const dataURL = canvas.toDataURL('image/png');
      this.stampImage = dataURL;
    },
    // 查询需方企业
    inquireEnterprise: function(key) {
      let session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        modeCode: 'Il9LhbAju1Qa9XCqFEb6CPSTFnxJxWwR',
        enterpriseId: session.enterpriseId,
        keyword: key || ''
      };
      this.$http.post(data).then((res) => {
        this.getPage(1);
        if (res.code == 1) {
          this.companyList = res.data;
        }
      });
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
      }
      return fmt;
    },
    changePage(page) {
      this.getPage(page);
    },
    changeStatus() {
      this.getPage(1);
    },
    handleChange(dateRange) {
      const arr = [];
      arr[0] = dateRange[0].replace(/\//g, '-');
      arr[1] = dateRange[1].replace(/\//g, '-');
      this.dateRange = arr;
    },
    handleConfirm() {
      this.getPage(1);
    },
    getSelect() {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        enterpriseId: session.enterpriseId,
        modeCode: '8Nj3MDYFYm6AMtHz8dYeDsMk7bEAC8Cg'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.forEach((item) => {
            let obj = {};
            obj.value = item.oreId;
            obj.label = item.oreName;
            this.oreList.push(obj);
          });
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getPage(index) {
      this.loading = true;
      let session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        modeCode: 'pPde69hPjz51Tp0ew9pImfsimNKgVLNo',
        enterpriseId: session.enterpriseId,
        userId: session.userId,
        pageIndex: index,
        pageSize: this.pageSize
      };
      if (this.dateRange.length != 0) {
        data.passStationTimeStart = this.dateRange[0];
        data.passStationTimeEnd = this.dateRange[1];
      }
      this.select1 && this.select1 != '全部' ? (data.oreId = this.select1) : data;
      this.needCom ? (data.buyerName = this.needCom) : data;
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.total = res.data.count;
          this.tableData = res.data.result_ctn;
          this.moneyObj = res.data.total;
          this.loading = false;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
          this.loading = false;
        }
      });
    },
    // 导出接口
    exportTable() {
      var session = JSON.parse(localStorage['session']);
      let data = {
        modeCode: 'HkO0tTRKlrCfsi5ty8rDhVQerhG1xe2s',
        sessionId: session.sessionId,
        enterpriseId: session.enterpriseId,
        fileName: '过站信息查询', //导出文件名称
        suffix: 'xlsx' //导出文件类型
      };
      if (this.dateRange.length != 0) {
        data.passStationTimeStart = this.dateRange[0];
        data.passStationTimeEnd = this.dateRange[1];
      }
      this.select1 && this.select1 != '全部' ? (data.oreId = this.select1) : data;
      this.needCom ? (data.buyerName = this.needCom) : data;
      this.$http.exportMethod(data).then((res) => {
        if (res.code == 1) {
          console.log(res, 'success');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 980px;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #f2f3f5;
  position: relative;

  .top-box {
    background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
    border-radius: 10px 10px 0 0;
    width: 100%;
    height: 40px;

    & > div {
      height: 100%;
      width: 928px;
      margin: 0 auto;
    }

    .title-label {
      width: 4px;
      height: 14px;
      background: #2c59c3;
    }

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #2c59c3;
      letter-spacing: 0.4px;
      margin-left: 6px;
    }

    .addOrg {
      background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
      border: 1px solid #4c9b25;
      border-radius: 6px;
      width: 110px;
      height: 30px;
      cursor: pointer;

      &:hover {
        background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
      }

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }

      .btn {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
      }
    }
  }

  .search-box {
    height: 74px;

    .label {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #616c84;
      letter-spacing: 0;
      margin-right: 10px;
    }

    .select-box,
    .search-item,
    .dispatch-time {
      margin-left: 25px;
    }

    /deep/.ivu-select-selected-value {
      height: 38px;
      line-height: 38px;
      text-align: left;
    }

    /deep/.ivu-select-selection,
    /deep/.ivu-input {
      height: 38px;
      box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.17);
      border-radius: 4px;
    }

    /deep/ .ivu-input-suffix i {
      line-height: 38px;
    }

    /deep/.ivu-date-picker-focused input,
    /deep/.ivu-date-picker-focused input {
      font-size: 14px;
    }

    /deep/.ivu-select-selected-value,
    /deep/.ivu-select-item {
      text-align: start;
    }

    /deep/.ivu-input-with-suffix {
      cursor: pointer;
    }

    /deep/.ivu-select-selection {
      height: 38px;
      background: #ffffff;
      box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      border-radius: 8px;
    }

    /deep/.ivu-select-placeholder,
    /deep/.ivu-select-selected-value {
      height: 38px;
      line-height: 38px;
      padding-left: 24px;
      text-align: start;
    }

    /deep/.ivu-input-suffix {
      line-height: 38px;
    }

    /deep/.ivu-input-with-suffix {
      height: 38px;
      line-height: 38px;
      padding-left: 24px;
      background: #ffffff;
      box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      border-radius: 8px;
    }
  }

  .content-box {
    width: 980px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;

    .content {
      width: 928px;
      margin-top: 15px;

      .title-box {
        width: 928px;
        height: 40px;
        background-color: rgba(224, 229, 240, 0.3);

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #8b93a7;
          flex: 1;
        }
      }

      .item-box {
        width: 928px;
        height: 50px;

        .num {
          font-family: Impact;
          font-size: 24px;
          flex: 1;
          margin: 10px 0;
        }

        .num1 {
          color: #7ed321;
        }

        .num2 {
          color: #4a90e2;
        }

        .num3 {
          color: #2c59c3;
        }

        .num4 {
          color: #f5a623;
        }
      }

      /deep/ .ivu-table th {
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }

      /deep/ .ivu-table th:last-child {
        border-top-right-radius: 10px;
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }

      /deep/ .ivu-table th:first-child {
        // border-top-left-radius: 10px;
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }
    }
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: start;
    border-bottom: 1px solid #f3f3f3;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }
}
.table-box {
  width: 844px;
  height: 400px;
  margin: auto;
  box-sizing: border-box;
  border: 1px solid #e6e8ee;
  position: relative;
  padding: 10px;
  text-align: center;
  .title-box {
    text-align: center;
  }
  .title {
    font-family: PingFangHK-Medium;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 600;
  }
  /* 章 */
  .chapter-box {
    position: absolute;
    top: 20px;
    left: 45%;
  }

  .chapter-box img {
    width: 80px;
    height: 46px;
  }

  .subtitle {
    width: calc(100% - 30px);
    position: absolute;
    top: 2px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .subtitle .flex {
    display: flex;
  }

  .subtitle .right {
    text-align: right;
    font-family: PingFangHK-Medium;
    font-size: 16px;
    color: #626b80;
    letter-spacing: 0;
  }

  .subtitle .right-msg {
    font-family: PingFangHK-Medium;
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 600;
  }

  .code {
    width: 80px;
    height: 80px;
    overflow: hidden;
  }

  .area {
    margin-top: 16px;
    margin-left: 10px;
    width: 90px;
    height: 60px;
    line-height: 60px;
    border: 1px dashed #e6e8ee;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
  }

  /* 表格label样式 */
  .label {
    font-family: PingFangHK-Regular;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
  }

  /* 填充内容样式 */
  .fill {
    font-family: PingFangHK-Regular;
    font-size: 14px;
    color: #626b80;
    letter-spacing: 0;
    padding-left: 5px;
  }

  .table {
    margin-top: 50px;
    width: 100%;
    height: calc(100% - 70px);
    border: 1px solid #e6e8ee;
    border-bottom: 0;
    box-sizing: border-box;
  }

  /* 垂直水平都居中 */
  .center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .middle {
    display: flex;
    align-items: center;
  }

  .between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .row {
    width: 100%;
    height: 25%;
    display: flex;
    border-bottom: 1px solid #e6e8ee;
    box-sizing: border-box;
  }

  .middle-box {
    position: relative;
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .label-box {
    box-sizing: border-box;
    padding: 0 5px;
    font-family: PingFangHK-Regular;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    // writing-mode: vertical-rl !important;
    i {
      font-style: normal;
      display: block;
    }
  }

  .fill-box {
    box-sizing: border-box;
    width: calc(100% - 30px);
    height: 100%;
    border-left: 1px solid #e6e8ee;
    border-right: 1px solid #e6e8ee;
    padding-top: 10px;
  }

  .fill-box2 {
    border-right: 0;
  }

  /* 第二行标题 */
  .row-title {
    width: 15%;
    box-sizing: border-box;
  }
  /* 合同编号 */
  .row-title:first-child {
    width: 20%;
  }
  /* 品种名称 */
  .row-title:nth-child(2) {
    width: 18%;
  }
  /* 运输车号 */
  .row-title:nth-child(4) {
    width: 17%;
  }

  .table-title {
    padding: 5px;
    border-bottom: 1px solid #e6e8ee;
  }

  .row-title .fill {
    padding: 5px 0 5px 5px;
  }

  /* 第三行 */
  .row-title2 {
    width: 50%;
  }

  .row-title2 .fill {
    padding: 5px 0 5px 5px;
  }

  #circleBar {
    opacity: 0;
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  .chapter {
    position: absolute;
    top: -35px;
    right: 220px;
    bottom: 0;
    width: 120px;
    height: 120px;
    border-radius: 50%;
  }
}
</style>
